import type { RouteObject } from "react-router-dom";

import { Spinner } from "@/components/ui/v2/spinner";

import { MySpacePayroll } from "@/pages/(home)/(my-space)/payroll";
import { MySpacePayslipDetail } from "@/pages/(home)/(my-space)/payroll/payslip";
import { MySpaceDisputes } from "@/pages/(home)/(my-space)/payroll/disputes";
import { MySpaceDisputeDetail } from "@/pages/(home)/(my-space)/payroll/disputes/detail";
import { addSlashes } from "../route.utils";

export enum MS_PAYROLL_PATH_SEGMENTS {
  ROOT = "payroll",
  PAYSLIP = "payslips",
  DISPUTES = "disputes",
}

export const myspacePayrollRoutes: RouteObject = {
  path: MS_PAYROLL_PATH_SEGMENTS.ROOT,
  HydrateFallback: Spinner,
  handle: { breadcrumb: "Payroll" },
  children: [
    { index: true, Component: MySpacePayroll },
    {
      path: `${MS_PAYROLL_PATH_SEGMENTS.PAYSLIP}/:id`,
      handle: { breadcrumb: "Payslip" },
      Component: MySpacePayslipDetail,
    },
    {
      path: MS_PAYROLL_PATH_SEGMENTS.DISPUTES,
      handle: { breadcrumb: "Disputes" },
      Component: MySpaceDisputes,
    },
    {
      path: `${MS_PAYROLL_PATH_SEGMENTS.DISPUTES}/:id`,
      handle: { breadcrumb: "Dispute Detail" },
      Component: MySpaceDisputeDetail,
    },
  ],
};

export const MS_PAYROLL_PATHS = Object.freeze({
  ROOT: addSlashes(MS_PAYROLL_PATH_SEGMENTS.ROOT),
  PAYSLIP: (id: string | number) =>
    addSlashes(
      MS_PAYROLL_PATH_SEGMENTS.ROOT,
      MS_PAYROLL_PATH_SEGMENTS.PAYSLIP,
      String(id),
    ),
});
